import { getBenchmarkId, getUrlParameter, HandleCookies } from '@/utils';

const addTagsParameters = [];

export function loadZendeskScript({ user, pod }) {
  const scriptElement = document.createElement('script');
  const firstScriptElement = document.getElementsByTagName('script')[0];

  scriptElement.type = 'text/javascript';
  scriptElement.async = true;
  scriptElement.id = 'ze-snippet';
  scriptElement.src = 'https://static.zdassets.com/ekr/snippet.js?key=aef27157-dd7e-4833-8506-1def2716dd0d';

  firstScriptElement.parentNode.insertBefore(scriptElement, firstScriptElement);

  scriptElement.addEventListener('load', () => {
    startZendesk({ user, pod });
  });
}

function jwtFn(callback) {
  fetch('/zendesk/jwt').then((res) => {
    res.text().then((jwt) => {
      const parsedJwt = JSON.parse(jwt);

      if (parsedJwt.status === 'DATA') {
        return callback(parsedJwt.message);
      }
    });
  });
}

function startZendesk({ user, pod }) {
  const benchmarkId = getBenchmarkId();
  const planId = getUrlParameter('plan_id') || HandleCookies.getCookies({ name: 'plan-id' });
  const lang = 'pt';

  addTagsParameters.push([
    `idioma_${lang}`,
    `benchmarks_id=${benchmarkId}`,
    `plan_id=${planId}`,
    `pod=${pod}`,
  ]);

  window.zE(function () {
    window.$zopim(function () {
      window.$zopim.livechat.addTags(...addTagsParameters);
    });
  });

  const preFillData = {
    name: {
      value: user.name,
      readOnly: true, // optional
    },
    email: {
      value: user.email,
      readOnly: true, // optional
    },
  };

  window.zE('webWidget', 'setLocale', 'pt-br');
  window.zE('webWidget', 'prefill', preFillData);

  window.zESettings = {
    webWidget: {
      authenticate: {
        chat: jwtFn,
      },
    },
  };
}
